module.exports = __webpack_public_path__ + "img/makco-logo.9829383c.jpeg";